<template>
  <iModal
    :visible="isCreateAdModalOpen"
    title="Create Publication Ad"
    primary-action-button-label="Create Ad"
    :primary-action-button-loading="isCreateAdLoading"
    :max-width="600"
    @close="closeModal"
    @click:primary="handleSubmit"
  >
    <template #body>
      <iColumn gap="large">
        <iSelect
          v-model="form.adType"
          :items="adTypes"
          label="Ad Type"
          text-field="label"
          value-field="value"
          width="fill"
        />

        <NativeAdForm
          v-if="form.adType === 'native'"
          v-model="form"
          :errors="errors"
          :is-loading="isLoadingUploadAdImage"
          @upload-image="handleImageSelected"
          @clear-error="clearError"
        />

        <iText v-if="adActionError" variant="error">
          {{ adActionError }}
        </iText>
      </iColumn>
    </template>
  </iModal>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { usePublicationAdsStore } from "%/stores/publication-ads-store";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";
import { AD_TYPES, DISABLED_AD_TYPES } from "@/constants/ad-type-constants";
import { SPONSORED_BY_PREFIX_OPTIONS } from "@/constants/sponsored-by-prefix-constants";
import NativeAdForm from "@/components/publication/NativeAdForm.vue";

export default {
  name: "CreatePublicationAdModal",
  components: { NativeAdForm },
  data() {
    return {
      form: {
        adType: AD_TYPES[0].value,
        name: "",
        title: "",
        description: "",
        sponsoredByPrefix: SPONSORED_BY_PREFIX_OPTIONS[0].value,
        destinationUrl: "",
        imageUrl: "",
      },
      adTypes: AD_TYPES,
      errors: {
        name: "",
        title: "",
        description: "",
        image: "",
      },
      disabledAdTypes: DISABLED_AD_TYPES,
    };
  },
  computed: {
    ...mapState(usePublicationAdsStore, [
      "isCreateAdModalOpen",
      "isCreateAdLoading",
      "isLoadingUploadAdImage",
      "adActionError",
    ]),
    ...mapState(useCreatorPublicationStore, ["publicationId"]),
  },
  watch: {
    isCreateAdModalOpen(newVal) {
      if (newVal) {
        this.resetForm();
      }
    },
  },
  methods: {
    ...mapActions(usePublicationAdsStore, [
      "closeCreateAdModal",
      "createAd",
      "uploadAdImage",
    ]),
    clearError(field) {
      this.errors[field] = "";
    },
    clearErrors() {
      this.errors = { name: "", title: "", description: "", image: "" };
    },
    resetForm() {
      this.form = {
        adType: AD_TYPES[0].value,
        name: "",
        title: "",
        description: "",
        sponsoredByPrefix: SPONSORED_BY_PREFIX_OPTIONS[0].value,
        destinationUrl: "",
        imageUrl: "",
      };
      this.clearErrors();
    },
    handleImageSelected(file) {
      this.uploadAdImage(file, 0, url => {
        this.form.imageUrl = url;
      });
    },
    validate() {
      let isValid = true;
      if (!this.form.name) {
        this.errors.name = "Name is required";
        isValid = false;
      }
      if (!this.form.title) {
        this.errors.title = "Title is required";
        isValid = false;
      }
      if (!this.form.description) {
        this.errors.description = "Description is required";
        isValid = false;
      }
      if (!this.form.imageUrl) {
        this.errors.image = "Image is required";
        isValid = false;
      }
      return isValid;
    },
    handleSubmit() {
      if (!this.validate()) {
        return;
      }
      this.createAd({
        publicationId: this.publicationId,
        name: this.form.name,
        title: this.form.title,
        imageUrl: this.form.imageUrl,
        description: this.form.description,
        sponsoredByPrefix: this.form.sponsoredByPrefix,
        destinationUrl: this.form.destinationUrl,
      });
    },
    closeModal() {
      this.closeCreateAdModal();
    },
  },
};
</script>

<style scoped>
</style>
